import { render, staticRenderFns } from "./ConsumeOTBitacora.vue?vue&type=template&id=16ce358a&"
import script from "./ConsumeOTBitacora.vue?vue&type=script&lang=js&"
export * from "./ConsumeOTBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports